import React from 'react';
import 'aframe';
import { getAframeFont } from '../../../components/AFrame/utils/fontHelpers';
import { getLabelTheme } from '../../../components/AFrame/utils/themeHelpers';
import { HOTSPOT_LABEL_THEME } from '../../../constants';
import '../components/AframeTextBackground.js';

const AframeTitle = ({
  id,
  title,
  iconSize,
  fontWeight = 'bold',
  fontName = 'roboto',
  value,
  hotspotLabelTheme = HOTSPOT_LABEL_THEME.DEFAULT,
  align = 'center',
  primaryColor,
  darkMode = false,
  ...rest
}) => {
  const height = iconSize?.size || 1;
  const scaleOffset = (5 - height) * 0.25;
  const position = `0 ${(height + scaleOffset) / 2} 0`;
  const displayText = title || value;
  const { font, fontImage } = getAframeFont({ fontName, fontWeight });
  const { textColor, backgroundColor } = getLabelTheme(hotspotLabelTheme, primaryColor, darkMode);

  const needsBackground = backgroundColor !== 'transparent';

  return (
    <a-entity
      position={position}
      id={id}
      visible="false"
    >
      {needsBackground ? (
        <a-entity
          text={`
            value: ${displayText};
            color: ${textColor};
            align: ${align};
            width: 10;
            font: ${font};
            font-image: ${fontImage};
            shader: msdf;
            negate: false;
            anchor: center;
          `}
          text-background={`color: ${backgroundColor}; textColor: ${textColor}`}
          {...rest}
        />
      ) : (
        <a-text
          value={displayText}
          color={textColor}
          align={align}
          width={10}
          font={font}
          font-image={fontImage}
          shader="msdf"
          negate={false}
          anchor="center"
          {...rest}
        />
      )}
    </a-entity>
  );
};

export default AframeTitle;
